// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","copyright":"Footer_copyright__ji7jm","social":"Footer_social__ZLhSK","icons":"Footer_icons__dd2DV","tiktok":"Footer_tiktok__LgzvL"};